export enum ModalType {
  Claimed = "Claimed",
  DeleteEverythingConfirmation = "DeleteEverythingConfirmation",
  DemoNote = "DemoNote",
  EditBoardMetadata = "EditBoardMetadata",
  Expiration = "Expiration",
  FeatureGateForImageUpload = "FeatureGateForImageUpload",
  FillColor = "FillColor",
  FillColorForSticky = "FillColorForSticky",
  GuestUsername = "GuestUsername",
  ImageExport = "ImageExport",
  ImageLibrary = "ImageLibrary",
  ImageUpload = "ImageUpload",
  PDFImport = "PDFImport",
  Share = "Share",
  StrokeColor = "StrokeColor",
  StrokeWidth = "StrokeWidth",
}
